import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";

import { Toast } from '../components_root/ToastContext.jsx';
import "./pricing.css";
import { Create_services } from '../services_root/create_services.js';
import { Randomcode } from '../components_root/rendom_code.js';
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account.js";
import { Verify_services_status } from '../services_root/verify_services_status.js';
import { MdCalendarMonth, MdDone, MdDoneAll } from 'react-icons/md';
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Pricing() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companydata, setCompanydata] = useState([]);
    const [servicesdata, setServicesdata] = useState([]);
    const [serviceid, setServiceId] = useState("nHjKn3hpo5HL5fAcw9JI");
    const servicetablename = "accountingfinancedb";
    const [domain_registration, setDomain_registration] = useState("");
    //staff account verify
    const [companiesstatus, setCompaniesstatus] = useState(false);
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffstype, setStafftype] = useState();
    const [staffdata, setStaffdata] = useState([]);
    const [eorrdata, setEorrdata] = useState();

    //Verify_services_status
    const [services_status, setServices_status] = useState(false);
    const [services_statusdata, setServices_statusdata] = useState([]);
    const [userlogin, setuserlogin] = useState(false);

    const [guid, setGuid] = useState("");
    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        const guids = Cookies.get("guid");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined && guids !== null && guids !== undefined) {
            setuserlogin(true);
            setGuid(guid);
        } else {
            // navigate("../login");
        }
    }, [navigate]);

    useEffect(() => {
        const get_verify_services_status_companies = async () => {
            try {
                const result = await Verify_services_status("company");

                if (!result || result.success == true) {
                    // failure case
                    //setServices_statusdata(result?.data || null);

                    setCompaniesstatus(true);
                    return;
                }


            } catch (e) {
                setCompaniesstatus(false);
                // setEorrdata("Verify Error:", e);
            }
        };
        get_verify_services_status_companies();
    }, []);
    const get_verify_services_status = async () => {
        try {
            const result = await Verify_services_status("accountingfinancedb");

            if (!result || result.success == true) {
                // failure case
                setServices_statusdata(result?.data || null);

                setServices_status(true);
                return;
            }


        } catch (e) {
            setServices_status(false);
            // setEorrdata("Verify Error:", e);
        }
    };
    useEffect(() => {
        const verifyStaffAccount = async () => {
            try {
                const accountguid = Cookies.get("guid");
                const result = await Verify_stafftype_account(accountguid);

                if (result.success) {
                    setStaffdata(result.data);
                    setStaffstatus(true);
                    setStafftype(result.data.account_type); // async update
                    //setEorrdata(staffdata);

                    // success case
                    if (result.data.account_type == "admin") {
                        get_verify_services_status();
                    }

                } else {
                    // setEorrdata("Verify Error:");
                }
            } catch (e) {

                setEorrdata("Verify Error:", e);
            }
        };
        verifyStaffAccount();
    }, []);
    useEffect(() => {
        const fetchCompany = async () => {
            const guid = Cookies.get("guid");
            const select_company_uid = Cookies.get("select_company_uid");

            if (!select_company_uid) {
                //navigate("/create-company");
                return;
            }

            //   if (!staffstatus.account_type == "admin") return

            // if (select_company_uid == aooz_company_uid) {
            //     return;
            // }

            const docRef = doc(db, "companies", select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const companyData = {
                    id: docSnap.id,
                    ...docSnap.data(),
                };

                setCompanydata([companyData]); // store as array for map()
            } else {
                // navigate("/create-company");
                setCompanydata([]);
            }
        };

        fetchCompany();
    }, []);
    useEffect(() => {
        if (!serviceid) return;

        const fetchVoucher = async () => {
            try {
                const docRef = doc(db, "servicesdb", serviceid);
                const docSnap = await getDoc(docRef);
                if (!docSnap.exists()) return;
                setServicesdata([{ ...docSnap.data() }]);
            } catch (err) {
                console.error(err);
            }
        };

        fetchVoucher();
    }, [serviceid]);

    const Create_services_handle = async () => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        const data = {
            servicetablename,
            serviceid,
            companyuid: select_company_uid,
            servicetablename,
            serviceid,
            ...servicesdata[0],
            banner_url: "https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/services_icon%2Fsite_design.jpg?alt=media&token=8df269d3-5a6e-4c66-972a-95a7746547d3",
        };

        const result = await Create_services(data);
        if (result.success) {
            navigate(`/${servicesdata[0].slug}`);
            Toastshow("Service created successfully");
        } else {
            Toastshow(`Error: ${result.error}`);
        }
    };

    return (
        <div>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots relative">


                <div className=" globe-bg"></div>
                <div className="container_size_info p-3 z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div key={row.id}  >

                            <table>
                                <tr>
                                    <td className='text-hero bold center'>Control Your Business</td>
                                </tr>
                                <tr>
                                    <td>

                                        <div className="text-h1 bold center" >{row.name}</div>
                                    </td>
                                </tr>
                                <tr>

                                    <td>
                                        <div className="text-h2 text-pre center test-off"  >{row.description}</div>
                                    </td>
                                </tr>
                            </table>

                        </div>
                    ))}


                </div>
                <div className="container_priceing z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div key={row.id} className="items-back shadow">
                            <div className="center border_top b-bottom">
                                <div className="text-hero orange bold fcap  center">

                                    <span className="text-h2 no-tx-text-loop black">Cost only</span>
                                    ₹{row.validity_day > 0
                                        ? (row.price / row.validity_day).toFixed(2)
                                        : "0.00"}
                                    <span className="text-h2 bold"> / day</span>
                                </div>
                            </div>
                            <div className='p-22'>
                                <table className='table_padding'>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >All accounting and stock management functions are available</div>
                                        </td>
                                        <td width={120}>
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Options are provided based on your requirements, free of charge.</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >As per requirement — Free setup</div>
                                        </td>
                                        <td  >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off " >POS Receipt</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off " >POS Billing</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Message Option</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Whatsapp</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td  >
                                            <div className="text-h3 text-off fcap" >Message Option</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Text SMS</div>

                                        </td>
                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Two-Step Queue Verification</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Queue</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Validity day</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdCalendarMonth className='icon' />{row.validity_day} Days</div>

                                        </td>

                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Billing yearly</div>
                                        </td>
                                        <td>
                                            <div className="text-h2  fcap" >₹{row.price}/-</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Tax (GST)</div>
                                        </td>
                                        <td>
                                            <div className="text-h2  fcap" >₹{row.tax_rate}%</div>

                                        </td>
                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >total Payable </div>
                                        </td>
                                        <td>
                                            <div className="text-h1 fcap bold">
                                                ₹{(row.price + (row.price * row.tax_rate / 100)).toFixed(2)}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            {services_status === true ? (
                                <div className='button-ui fill text-h2  bold fcap p-2 cursor' onClick={() => navigate(`/payment-gateway?token=${Randomcode(400)}&id=${row.serviceid}`)}>Renew</div>
                            ) : (
                                <>
                                    {companiesstatus === false ? (
                                        <div className='button-ui p-3 fill  cursor text-h1  bold green-back' onClick={() => {
                                            if (userlogin === true) { navigate("/create-company") } else {
                                                navigate("/login")
                                            }
                                        }
                                        }

                                        >Start Installation </div>) : (<div onClick={() => Create_services_handle()} className='button-ui text-h2 fcap p-2 cursor green-back'>Start Installation </div>)}
                                </>
                            )}

                        </div>
                    ))}

                </div>
                <br />
                <div className="container_size_info z-index-2">
                    <div className=' text-h2 text-r'>Looking for corporate deals? <a href='https://aooz.in/support' className='bold cursor'>Contact us</a>  today.</div>
                </div>
                <div className="container_size p-3 z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div className="text-h3 text-pre" >{row.about}</div>
                    ))}
                </div>
            </div>

        </div >
    );
}
